<template>
  <SectionContainerPage>
    <SectionActivityTypeList
      xs12
      :activityTypeList="activityTypeList"
      :assetStatusList="assetStatusList"
      :shouldShowSearch="true"
      :toolbarActions="[
        {
          text: 'Activity Type',
          icon: 'add',
          iconColor: 'success',
          emitEvent: 'onAddNewActivityTypeClicked',
        },
      ]"
      @onAddNewActivityTypeClicked="showDialogFormActivityTypeAdd = true"
      @onEditActivityTypeClicked="
        (val) => [
          (activityTypeToEdit = val.activityTypeToEdit),
          (showDialogFormActivityTypeEdit = true),
        ]
      "
      :isLoading="isLoading"
    />
    <DialogFormActivityTypeAdd
      :showDialog="showDialogFormActivityTypeAdd"
      @onCancelClicked="showDialogFormActivityTypeAdd = false"
      @onSubmitClicked="(val) => [onDialogFormActivityTypeAddSubmit(val)]"
      :assetStatusList="assetStatusList"
      :isLoading="isLoading"
    />
    <DialogFormActivityTypeEdit
      :showDialog="showDialogFormActivityTypeEdit"
      :activityTypeToEdit="activityTypeToEdit"
      @onCancelClicked="showDialogFormActivityTypeEdit = false"
      @onSubmitClicked="(val) => [onDialogFormActivityTypeEditSubmit(val)]"
      :assetStatusList="assetStatusList"
      :isLoading="isLoading"
    />
    <DialogFormConfirmation
      :showDialog="confirmationDialogShow"
      :title="confirmationDialogTitle"
      :message="confirmationDialogMessage"
      :submitButtonText="confirmationDialogSubmitButtonText"
      :submitButtonIcon="confirmationDialogSubmitButtonIcon"
      :submitButtonColor="confirmationDialogSubmitButtonColor"
      :cancelButtonText="confirmationDialogCancelButtonText"
      :showCancelButton="confirmationDialogShowCancelButton"
      @onSubmitClicked="onConfirmationDialogSubmitClicked"
      @onCancelClicked="onConfirmationDialogCancelClicked"
      :isLoading="isLoading"
    />
  </SectionContainerPage>
</template>

<script>
import mixinAssetApi from '../../../common/mixins/mixinAssetApi'
import mixinAssetHelper from '../../../common/mixins/mixinAssetHelper'
import mixinConfirmationDialog from '../../../common/mixins/mixinConfirmationDialog'

import SectionContainerPage from '../../../common/components/layouts/SectionContainerPage'
import SectionActivityTypeList from './sections/SectionActivityTypeList'
import DialogFormActivityTypeAdd from '../dialogs/DialogFormActivityTypeAdd'
import DialogFormActivityTypeEdit from '../dialogs/DialogFormActivityTypeEdit'
import DialogFormConfirmation from '../dialogs/DialogFormConfirmation'

export default {
  components: {
    SectionContainerPage,
    SectionActivityTypeList,
    DialogFormActivityTypeAdd,
    DialogFormActivityTypeEdit,
    DialogFormConfirmation,
  },
  mixins: [mixinAssetApi, mixinAssetHelper, mixinConfirmationDialog],
  props: {},
  data: () => ({
    showDialogFormActivityTypeAdd: false,
    showDialogFormActivityTypeEdit: false,
    activityTypeList: [],
    assetStatusList: [],
    activityTypeToEdit: {},
    isLoadingCount: 0,
  }),
  activated() {
    this.fetchLists()
  },
  computed: {
    isLoading() {
      return this.isLoadingCount > 0
    },
  },
  watch: {
    isLoading() {
      this.$emit('isLoadingChange', this.isLoading)
    },
  },
  methods: {
    onDialogFormActivityTypeAddSubmit(data) {
      this.isLoadingCount++
      this._insertActivityType({
        name: data.name,
        assetStatusIds: data.assetStatusIds,
        isStatusChange: data.isStatusChange,
        isLocationChange: data.isLocationChange,
        isUpcoming: data.isUpcoming,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormActivityTypeAdd = false
          this.fetchLists()
          this.$emit('notify', {
            message: 'Activity type successfully created!',
          })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    onDialogFormActivityTypeEditSubmit(data) {
      this.isLoadingCount++
      this._updateActivityType({
        id: data.id,
        name: data.name,
        assetStatusIds: data.assetStatusIds,
        isUpcoming: data.isUpcoming,
        isStatusChange: data.isStatusChange,
        isLocationChange: data.isLocationChange,
        isEnabled: data.isEnabled,
        successCb: () => {
          this.isLoadingCount--
          this.showDialogFormActivityTypeEdit = false
          this.fetchLists()
          this.$emit('notify', {
            message: 'Activity type successfully updated!',
          })
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
    fetchLists() {
      this.isLoadingCount++
      this._fetch({
        types: ['Status', 'ActivityType'],
        successCb: (data) => {
          this.isLoadingCount--
          this.activityTypeList = data.activityTypes
          this.assetStatusList = data.statuses
        },
        failedCb: (error) => {
          this.isLoadingCount--
          this.assetStatusList = []
          this.activityTypeList = []
          this.showConfirmationDialog({
            title: 'Error occured',
            showCancelButton: false,
            message: this._getMessageFromErrorResponse(error),
            submitButtonText: 'Continue',
          })
        },
      })
    },
  },
}
</script>
